import { useCallback } from 'react';

const TIER_PRICES = {
  basic: 45.0,
  standard: 90.0,
  premium: 180.0,
};

const getDiscountRate = (packs) => {
  if (packs >= 20) return 0.12;
  if (packs >= 5) return 0.05;
  return 0.0;
};

export const calcPricing = (tier, packs) => {
  const packPrice = TIER_PRICES[tier] || TIER_PRICES['standard'];
  const subtotal = packPrice * packs;
  const discount = getDiscountRate(packs);
  const discountAmount = subtotal * discount;
  const total = subtotal - discountAmount;
  const leads = packs * 25;
  const perLead = leads > 0 ? total / leads : 0;
  return { packPrice, subtotal, discount, discountAmount, total, leads, perLead };
};

export function usePricing(pricingTier = 'standard', pricingPacks = 1) {
  const downloadPricingCSV = useCallback(() => {
    const rows = [];
    const tiers = ['basic', 'standard', 'premium'];
    for (const t of tiers) {
      for (let p = 1; p <= Math.max(10, pricingPacks); p++) {
        const c = calcPricing(t, p);
        rows.push([
          t,
          p,
          c.leads,
          c.packPrice.toFixed(2),
          `${(c.discount * 100).toFixed(0)}%`,
          c.total.toFixed(2),
          c.perLead.toFixed(2),
        ]);
      }
    }
    const header = [
      'Tier',
      'Packs (25/leads)',
      'Leads',
      'Preço por pacote (R$)',
      'Desconto',
      'Preço total (R$)',
      'Preço por lead (R$)',
    ];
    const csv = [header, ...rows].map((r) => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `pricing_table_${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }, [pricingPacks]);

  const pricing = calcPricing(pricingTier, pricingPacks);

  return { pricing, downloadPricingCSV };
}
